module.exports = __webpack_public_path__ + "img/banner3.9d815710.png";